<template>
    <div class="page">
      <div class="layout">
        <el-row type="flex" align="middle" :gutter="8">
          <el-col :span="1">
            <i class="el-icon-back" style="cursor: pointer;" @click="onBackUser"></i>
          </el-col>
          <el-col :span="12">
            <div class="page-title">學習表現</div>
          </el-col>
        </el-row>
        <div class="page-content">
          <div class="page-title" style="padding-top:30px;padding-bottom:10px; text-align: center;">學生 Student : <span class="page-title-span">{{ userNo }}</span></div>
          <div class="page-title-row" style="margin-bottom:10px;">
             <div :class="activation == 'Adventure Mode' ? 'page-title-row-select' : ''" @click="onTiltClick('Adventure Mode')">
                <div>冒險模式</div>
                <div>Adventure Mode</div>
             </div>
             <div :class="activation == 'Homework' ? 'page-title-row-select' : ''" @click="onTiltClick('Homework')">
                <div>作業</div>
                <div>Homework</div>
             </div>
          </div>
          <div class="page-box">
            <div class="page-content-row" v-show="activation == 'Adventure Mode'">
              <div>
                <div class="search-text">年級</div>
                <el-select v-model="listQuery.gradeId" clearable placeholder="全部年級">
                  <el-option
                    v-for="(item, index) in grades"
                    :key="index"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </div>
              <div>
                <div class="search-text">星星</div>
                <el-select v-model="listQuery.star" placeholder="全部">
                  <el-option
                    v-for="item in stars"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </div>
              <div>
                <div class="search-text">搜尋</div>
                <el-input
                  v-model="listQuery.keywords"
                  placeholder="關鍵字"
                ></el-input>
              </div>
              <div>
                <div class="search-text">課程版本</div>
                <el-select v-model="listQuery.lang" placeholder="請選擇課程版本">
                  <el-option
                    v-for="item in languages"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </div>
              <div>
                <el-button type="info" class="button-el-el" @click.native="onSearch('Adventure Mode')"
                  >搜尋</el-button
                >
              </div>
              <div>
                <el-button
                  type="success"
                  class="button-el-el"
                  @click.native="onReset"
                  >清除篩選</el-button
                >
              </div>
            </div>
            <div class="homeworkQuery-content-row" v-show="activation == 'Homework'">
              <div>
                <div class="search-text">開始日期</div>
                  <el-date-picker
                    v-model="homeworkQuery.startDate"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="选择日期">
                  </el-date-picker>
              </div>
              <div>
                <div class="search-text">結束日期</div>
                  <el-date-picker
                    v-model="homeworkQuery.endDate"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="选择日期">
                  </el-date-picker>
              </div>
              <div>
                <div class="search-text">搜尋</div>
                <el-input
                  v-model="homeworkQuery.keywords"
                  placeholder="搜尋"
                ></el-input>
              </div>
              <div>
                <div class="search-text">課程版本</div>
                <el-select v-model="homeworkQuery.lang" placeholder="請選擇課程版本">
                  <el-option
                    v-for="item in languages"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </div>
              <div>
                <el-button type="info" class="button-el-el" @click.native="onSearch('Homework')"
                  >搜尋</el-button
                >
              </div>
              <div>
                <el-button
                  type="success"
                  class="button-el-el"
                  @click.native="onReset"
                  >清除篩選</el-button
                >
              </div>
            </div>
          </div>
          <el-table v-show="activation == 'Adventure Mode'" :data="adventure" style="width: 100%;">
            <el-table-column width="15"></el-table-column>
            <el-table-column label="年級">
              <template slot-scope="{ row }">
                <span>{{ row.gradeName }}</span>
              </template>
            </el-table-column>
            <el-table-column
                prop="number"
                label="課題編號">
            </el-table-column>
            <el-table-column
              prop="name"
              label="課題名稱">
            </el-table-column>
            <el-table-column
              prop="lang"
              label="課程版本">
              <template slot-scope="{ row }">
                 <span>{{ row.lang |language }}</span>
              </template>
            </el-table-column>
            <el-table-column label="練習(完成數/總數)">
              <template slot-scope="{ row }">
                 <span>{{ row.practiseCompletedQuantity }}/{{ row.practiseTotalQuantity }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="star" label="星星">
              <template slot-scope="scope">
                        <img :src="scope.row.star > 0 ? require('@/assets/images/star-light.png') : require('@/assets/images/star-dark.png')" />
                        <img :src="scope.row.star > 1 ? require('@/assets/images/star-light.png') : require('@/assets/images/star-dark.png')" />
                        <img :src="scope.row.star > 2 ? require('@/assets/images/star-light.png') : require('@/assets/images/star-dark.png')" />
              </template>
            </el-table-column>
          </el-table>
          <el-table v-show="activation == 'Homework'" :data="homeworks" style="width: 100%;">
            <el-table-column width="15"></el-table-column>
            <el-table-column label="作業">
              <template slot-scope="{ row }">
                <span>{{ row.number }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="lang"
              label="課程版本">
              <template slot-scope="{ row }">
                 <span>{{ row.lang | language }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="startDate" label="開始日期及時間">
              <template slot-scope="{ row }">
                 <span>{{ row.startDate }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="endDate" label="到期日期及時間">
              <template slot-scope="{ row }">
                 <span>{{ row.endDate }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="completedAt" label="完成日期及時間">
              <template slot-scope="{ row }">
                 <span>{{ row.completedAt }}</span>
              </template>
            </el-table-column>
            <el-table-column :label="'分數'" width="140">
                <template slot-scope="{ row }">
                    <span>{{ row.correctQuantity + "/" + row.totalQuantity }}</span>
                </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <Pagination
        v-show="total > 0 && activation == 'Adventure Mode'"
        :total="total"
        :page.sync="listQuery._page"
        :limit.sync="listQuery._limit"
        @pagination="getAdventureModeLearningPerformance"
      />
      <Pagination
        v-show="homeworksTotal > 0 && activation == 'Homework'"
        :total="homeworksTotal"
        :page.sync="homeworkQuery._page"
        :limit.sync="homeworkQuery._limit"
        @pagination="getHomeworkLearningPerformance"
      />
    </div>
</template>
  
<script>
  import { getAdventureModeLearningPerformance,getHomeworkLearningPerformance } from '@/api/report'
  import Pagination from "@/components/Pagination";
  import {getGrades} from '@/api/grade'
  export default {
    components: { Pagination },
    data() {
      return {
        stars:[
          {
            label: '0',
            value:0
          },
          {
            label: '1',
            value:1
          },
          {
            label: '2',
            value:2
          },
          {
            label: '3',
            value:3
          },
        ],
        total: 0,
        homeworksTotal: 0,
        userId: null,
        listQuery: {
          studentId: null,
          numberLike: null,
          keywords: null,
          lang: null,
          scope: null,
          star: null,
          gradeId: null,
          orderBy: null,
          _page: 1,
          _limit: 10,
        },
        homeworkQuery: {
          studentId: null,
          keywords: null,
          startDate: null,
          endDate: null,
          gradeId: null,
          _page: 1,
          _limit: 10,
        },
        centerDialogVisible: false,
        dialogSlotVisible: false,
        adventure: [],
        homeworks: [],
        tableData: [],
        avatars: [],
        grades: [],
        titleActivation: 'Adventure Mode',
      };
    },
    computed:{
      studentId(){
        return this.$route.params.id
      },
      userNo(){
        return this.$route.params.userNo  
      },
      activation(){
        return this.titleActivation
      }
    },
    created() {
      this.listQuery.lang = Number(this.$route.query.studying);
      this.homeworkQuery.lang = Number(this.$route.query.studying);
      this.getGrades();
      this.getHomeworkLearningPerformance();
      this.getAdventureModeLearningPerformance();
    },
    methods: {
      onTiltClick(title){
        this.titleActivation = title
      },
      getHomeworkLearningPerformance(){
        let listQuery = {
          studentId: this.studentId,
          keywords: this.homeworkQuery.keywords,
          lang: this.homeworkQuery.lang,
          startDate: this.homeworkQuery.startDate,
          endDate: this.homeworkQuery.endDate,
          gradeId: this.homeworkQuery.gradeId,
          _page: this.homeworkQuery._page -1,
          _limit: this.homeworkQuery._limit,
        }
        getHomeworkLearningPerformance(listQuery).then((res)=>{
          this.homeworks = res.data
          this.homeworksTotal = Number(res.headers["x-total-count"]);
        })
      },
      getAdventureModeLearningPerformance(){
        this.listQuery.gradeId = Number(this.$route.query.gradeId);
        let listQuery = {
          studentId: this.studentId,
          keywords: this.listQuery.keywords,
          numberLike: this.listQuery.numberLike,
          lang: this.listQuery.lang,
          star: this.listQuery.star,
          orderBy: 'number asc',
          gradeId: this.listQuery.gradeId,
          _page: this.listQuery._page -1,
          _limit: this.listQuery._limit,
        }
        getAdventureModeLearningPerformance(listQuery).then((res)=>{
          this.adventure = res.data
          this.total = Number(res.headers["x-total-count"]);
        })
      },
      onBackUser() {
        let path = `/student`
        this.$router.push({path: path})
      },
      getGrades(){
        getGrades().then((res)=>{
          this.grades = res.data
        })
      },
      onSearch(val) {
        if(val== 'Adventure Mode'){
          this.getAdventureModeLearningPerformance();
        }else if(val == 'Homework'){
          this.getHomeworkLearningPerformance()
        }
      },
      onReset() {
        Object.keys(this.listQuery).forEach((key) => {
          this.listQuery[key] = null;
          if (key === "_page") {
            this.listQuery[key] = 1;
          } else if (key === "_limit") {
            this.listQuery[key] = 50;
          }
        })
        Object.keys(this.homeworkQuery).forEach((key) => {
          this.homeworkQuery[key] = null;
          if (key === "_page") {
            this.homeworkQuery[key] = 1;
          } else if (key === "_limit") {
            this.homeworkQuery[key] = 50;
          }
        })
      },
    },
  };
</script>
  
<style lang="scss" scoped>
  .page {
    .layout {
      .el-row {
        margin-bottom: 20px;
        &:last-child {
          margin-bottom: 0;
        }
  
        .title {
          font-size: 30px;
        }
      }
  
      .el-button--text {
        color: #166ea5;
        font-size: 16px;
      }
    }
    .demo-ruleForm-div {
      margin-top: 40px;
    }
    ::v-deep {
      .cell {
        color: black;
      }
    }
  }
  .form-avatar {
    position: relative;
    width: 90px;
    height: 90px;
  }
  .search-text {
    margin-bottom: 12px;
    color: #8e8e8e;
  }
  .page-content {
    background-color: #fff;
  }
  .page-box{
    width: 100%;
    max-width: 100%;
    overflow-x: auto;
  }
  .page-title-span{
    color: rgb(68, 68, 68);
  }
  .page-content-row {
      padding: 30px 10px;
      display: grid;
      padding: 5px;
      grid-template-columns: repeat(6, 1fr);
      grid-template-rows: repeat(1, 1fr);
      gap: 8px;
      grid-template-columns:1fr 1fr 1fr 1fr 80px 120px;
  }
  .homeworkQuery-content-row {
      padding: 30px 10px;
      display: grid;
      padding: 20px;
      grid-template-columns: repeat(6, 1fr);
      grid-template-rows: repeat(1, 1fr);
      gap: 8px;
      grid-template-columns:1fr 1fr 1fr 1fr  80px 120px;
  }
  .button-el-el {
    margin-top: 24px;
  }
  .studentCode{
    color: #027915;
  }
  .isStudentCode{
    color: #9C0000;
  }
  .page-title-row{
    display: flex;
    border: 1px solid #9C0000;
    width: 400px;
    margin: 0 auto;
    margin-top: 10px;
    border-radius: 30px;
    padding: 6px;
    text-align: center;
    justify-content: center;
    align-items: center;
    flex: 1;
    color: #9C0000;
  }
  .page-title-row>div{
    flex: 1;
    cursor: pointer;
  }
  .page-title-row-select{
    background-color: #9C0000;
    color: #fff;
    border-radius: 30px;
    padding: 6px;
  }
  ::v-deep{
    .el-select,.el-date-editor{
      width: 100%;
    }
  }
</style>